import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import { from, switchMap } from 'rxjs'

import { Preloader } from '@procom-labs/atoms'
import {
  AuthProfileType,
  IAccountType,
  LoginTypes,
  RecaptchaActions,
  useSubscriptionRef,
  VendorCodes,
} from '@procom-labs/common'
import { useAlert } from '@procom-labs/molecules'

import { BaseLayout } from '@auth-portal/components/base-layout'
import { VerifyDigitalCode } from '@auth-portal/components/verify-digital-code'
import { useAuthService, useRecaptcha } from '@auth-portal/hooks'
import { getCallbackURL, getOriginBaseUrl } from '@auth-portal/util'

export const SignupGorillaResumeOtp = () => {
  const { t, i18n } = useTranslation('main')
  const authService = useAuthService()
  const { addAlert } = useAlert()
  const [searchParams] = useSearchParams()
  const emailParam = searchParams.get('email')
  const signUpSubscriptionRef = useSubscriptionRef()
  const { getRecaptchaToken } = useRecaptcha()
  const [showVerifyCodeScreen, setShowVerifyCodeScreen] = useState(false)

  useEffect(() => {
    if (!emailParam || showVerifyCodeScreen) return
    signUpSubscriptionRef.current = from(
      getRecaptchaToken(RecaptchaActions.Signup)
    )
      .pipe(
        switchMap((recaptcha) =>
          // Create the GorillaResume user
          authService.createContactWithoutPassword(
            {
              email: emailParam,
              vendorCode: VendorCodes.GW,
              clientCode: null,
              language: i18n.language,
              authPortalBase: window.location.origin,
              callbackUrl: getCallbackURL(),
              originBase: getOriginBaseUrl(),
              firstName: '',
              lastName: '',
              recaptchaToken: recaptcha,
              portalType: LoginTypes.GorillaResume,
              profileType: AuthProfileType.GorillaResumeUser,
            },
            IAccountType.GorillaResume
          )
        ),
        switchMap(() =>
          from(getRecaptchaToken(RecaptchaActions.RequestResetPassword))
        ),
        switchMap((token) =>
          // Generate the OTP
          authService.generateSignInOtp(
            decodeURIComponent(emailParam),
            token,
            i18n.language
          )
        )
      )
      .subscribe({
        complete: () => {
          setShowVerifyCodeScreen(true)
        },
        error: () => {
          addAlert({
            message: t('common.alert.somethingWrong'),
            severity: 'error',
            horizontal: 'left',
          })
        },
      })
  })

  if (showVerifyCodeScreen && emailParam) {
    return (
      <BaseLayout>
        <VerifyDigitalCode email={emailParam} />
      </BaseLayout>
    )
  }
  return <Preloader center />
}
